require('./bootstrap')
require('bootstrap/dist/js/bootstrap')
require('bootstrap/js/dist/modal')


import Homepage from './modules/homepage'
import SwiperSlide from './modules/swiper'
import SlideSection15 from './modules/section15'


$(document).ready(function() {
    new Homepage()  
    new SwiperSlide()
    new SlideSection15()
    
    // AOS.init();
})

